import { MenuIconModel } from "model/MenuIcon.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = MenuIconModel[];

export const useDefaultObservableMenuIconModelArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectMenuIconModelArray extends BehaviorSubject<CurrentType> {}
